import React, { useRef, useState } from 'react';
import { updateProject } from '../../utils/api/project_apis';
import { STATUS } from '../../utils/api/sharedfunction';
import { TextField } from '@mui/material';
import ModalWrapper from '../ModalWrapper';
import CommonFooter from '../FormComponent/CommonFooter';
import { FormSchemas, FormWrapper } from '../FormComponent';


const EditProjectModal = ({ open, onClose, onEdit, onError , projectToUpdate, projects}) => {
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const handleEditProject = async (data) => {
    console.log("handleEditProject", data);
    try {
      setLoading(true);
      const result = await updateProject({
        id: projectToUpdate.id,
        name: data.projectName,
        description: data.projectDescription,
        context: data.projectContext
      });

      if (result.status === STATUS.SUCCESS) {
        onEdit(result.data);
        onClose();
      } else {
        onError('error update', result.error || 'Failed to update project');
      }
    } catch (error) {
      console.error('Error updating project:', error);
      onError('error update', error?.message || 'Failed to update project');
    } finally {
      setLoading(false);
    }
  };

  const handleFormSubmit = async () => {
    if (formRef.current) await formRef.current.submit();
  };

  const fields = [
    {
      name: 'projectName',
      type: 'text',
      label: 'Project Name',
      placeholder: 'Enter your full project name',
      required: true,
    },
    {
      name: 'projectDescription',
      type: 'text',
      label: 'Project Description',
      placeholder: 'Enter your project description',
      multiline: true,
      rows: 2
    },
    {
      name: 'projectContext',
      type: 'text',
      label: 'Project Context',
      placeholder: 'Enter your project context',
      multiline: true,
      rows: 2
    }
  ]

  const buttons = [
    {
      label: 'Cancel',
      variant: 'outline',
      className: 'primary',
      onClick: onClose,
      disabled: loading,
    },
    {
      label: 'Save',
      variant: 'primary',
      className: 'white bg-blue600',
      color: 'primary',
      onClick: handleFormSubmit,
      disabled: loading,
      loading: loading,
    },
  ];

  return (
    <ModalWrapper
      isOpen={open}
      onClose={onClose}
      title="Edit Project"
      size="small"
      footer={
        <CommonFooter
          buttons={buttons}
          align="right"
        />
      }
      children={
        <FormWrapper
          ref={formRef}
          schema={FormSchemas.projectForm(false)}
          fields={fields}
          onSubmit={handleEditProject}
          defaultValues={{
            projectName: projectToUpdate.name,
            projectDescription: projectToUpdate.description,
            projectContext: projectToUpdate.context,
          }}
        />
      }
    />
  );
};

export default EditProjectModal;